/* global VERSION BUILD */
import { trace } from './log';
import * as lib from './lib';
import { startListeningToSlots } from './data-attr-listener';

const globalName = 'marketing';
const version = VERSION;
const build = BUILD;

const exportGlobal = (lib, name = globalName) => {
  if (!window.TES) {
    window.TES = {};
  }
  if (!window.TES[name]) {
    window.TES[name] = lib;
  }
};

const docReady = (readyHandler) => {
  if (document.readyState === 'loading') {
    return document.addEventListener('DOMContentLoaded', readyHandler);
  }
  readyHandler();
};

docReady(() => {
  exportGlobal(lib);
  trace(`marketing loader lib v${version} build ${build} initialized`);
  setTimeout(startListeningToSlots);
});
